<template>
  <v-app :style="colorVapp">
    <onebox_admin_toolbar
      :quicksearch="true"
      @loaddata="loaddata()"
      @loadfile="get_employee()"
      @callstorage="loadstorage()"
      @closeDrag="removeEvent()"
      @openDrag="addEvent()"
    ></onebox_admin_toolbar>
    <v-content>
      <v-card class="elevation-0">
        <v-divider></v-divider>
        <v-overlay :value="processloader" absolute :color="color.BG" dark>
          <v-progress-circular indeterminate size="64" :color="color.theme"></v-progress-circular>
          <span :style="colorProgress">&nbsp; loading</span>
        </v-overlay>

        <!-- hearder -->
        <v-list nav :color="color.BG">
          <v-list-item class="text-left">
            <v-list-item-avatar class="text-center">
              <v-avatar :color="color.theme" size="35">
                <v-icon dark size="20">mdi-account-cog</v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="pa-1">
                <span :style="headerPage">&nbsp;{{ $t("admintoolbar.closeemployee") }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card class="elevation-0" :color="color.BG" id="thiscontainersetadmin">
          <v-card-text class="pa-0">
            <v-container fluid>
              <v-layout row wrap justify-center fill-height>
                <v-flex lg12 class="ma-2 ml-4 mr-4" v-if="loaddataprogress === true">
                  <div class="text-center">
                    <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular>
                  </div>
                </v-flex>
                <v-flex lg12 class="ma-4" v-else>
                  <v-layout row wrap class="pl-3 pr-3">
                    <v-flex lg2>
                      <v-text-field
                        class="pl-1"
                        :label="$t('admin.search')"
                        v-model="search"
                        clearable
                        outlined
                        dense
                        :color="color.theme"
                        append-icon="search"
                        @click:clear="get_employee(), (clicksearch = false),(search = '')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg1 class="pl-1">
                      <v-btn :color="color.theme" :dark="color.darkTheme" @click="search_employee(), (clicksearch = true)">{{
                        $t("admin.search")
                      }}</v-btn>
                    </v-flex>
                  </v-layout>
                  <!-- Phonee -->
                  <div v-if="loaddataprogresstable === true">
                    <v-flex lg12 class="ma-2 ml-4 mr-4">
                      <div class="text-center">
                        <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular>
                      </div>
                    </v-flex>
                  </div>
                  <div v-else>
                    <div v-if="resolutionScreen < 500">
                      <v-list two-line class="mb-6 pb-6 elevation-0" v-if="this.total_account !== 0">
                        <v-list-item v-for="item in staff" :key="item.title" style="cursor: pointer;">
                          <v-list-item-content>
                            <v-list-item-title v-if="$t('default') === 'th'" v-text="item.name_th"></v-list-item-title>
                            <v-list-item-title v-else v-text="item.first_name_eng"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.department_name"></v-list-item-subtitle>
                            <!-- <v-list-item-subtitle v-text="formatdatetime(item.process_dtm)"></v-list-item-subtitle> -->
                          </v-list-item-content>
                          <v-list-item-action>
                            <!-- <v-btn class="elevation-0" fab small @click="opendetaillog = true , detaildata = item"><v-icon >mdi-information</v-icon></v-btn> -->
                            <!-- <v-switch
                              @change="fn_confirm_set(item)"
                              v-model="item.status_admin"
                              inset
                              :color="color.theme"
                            ></v-switch> -->
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                      <v-list v-else class="mb-6 pb-6 elevation-0">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="text-center" v-text="$t('tablefile.empty')"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </div>
                    <!-- Labtop -->
                    <div v-else>
                      <v-data-table
                        :headers="$t('default') === 'en' ? headerEN : headerTH"
                        :items="all_data_employee"
                        class="elevation-0"
                        :no-data-text="$t('tablefile.empty')"
                        :page.sync="page"
                        :items-per-page="size"
                        :hide-default-footer="true"
                        @page-count="pageCount = $event"
                      >
                        <template v-slot:[`header.type`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-if="$t('default') === 'th'" v-slot:[`header.first_name_th`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-else v-slot:[`header.first_name_eng`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-slot:[`header.department_name`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-slot:[`header.username`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-slot:[`header.email`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>
                        <template v-slot:[`header.status`]="{ header }">
                          <span :style="headerTable">{{ $t(header.text) }}</span>
                        </template>

                        <template v-slot:item="props">
                          <tr>
                            <td width="7%" class="text-center">
                              <v-icon v-if="props.item.status_admin === true" :color="color.theme">mdi-account-star</v-icon>
                              <v-icon v-else>mdi-account</v-icon>
                            </td>
                            <td width="23%" v-if="$t('default') === 'th'">{{ props.item.first_name_th  + " " + props.item.last_name_th}}</td>
                            <td width="23%" v-else>{{ props.item.first_name_eng + " " + props.item.last_name_eng}}</td>
                            <td width="20%">{{ props.item.department_name }}</td>
                            <td width="20%">{{ props.item.username }}</td>
                            <td width="23%">{{ props.item.email }}</td>
                            <td width="10%" class="text-center">
                                      <v-menu>
                                        <template
                                          v-slot:activator="{ attrs, on }"
                                        >
                                          <v-btn
                                            class="elevation-0"
                                            fab
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                          >
                                            <v-icon>settings</v-icon>
                                          </v-btn>
                                        </template>
                                        <v-list>
                                          <v-list-item
                                            link
                                            @click="
                                              opendialog_close_user(props.item)
                                            "
                                          >
                                            <v-list-item-icon>
                                              <v-icon>mdi-account-minus</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                              <v-list-item-title>{{$t('admintoolbar.closeemployee')}}</v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                    <br />
                    <!-- <v-pagination
                      v-model="page"
                      :length="pageCount"
                      :color="color.theme"
                      :total-visible="10"
                      @input="clickpagination()"
                    ></v-pagination> -->
                    <v-layout row wrap justify-center>
                      <v-flex xs11 lg11 v-if="pageCount > 0">
                        <v-pagination
                          :total-visible="10"
                          v-model="page"
                          :length="pageCount || 0"
                          :color="color.theme"
                          @input="clickpagination()"
                        ></v-pagination>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-card>
    </v-content>
    <v-dialog v-model="isConfirmAdmin" scrollable persistent max-width="530" >
      <v-card>
                <v-card-text class="pt-5">
                    <div class="d-flex flex-column align-center" > 
                      <v-icon color="warning" size="120" >
                        mdi-alert-circle-outline
                      </v-icon>
                      <p class="font-weight-bold mt-2 pa-3 text-center" style="font-size: 30px; line-height: 35px;" > 
                        {{$t("toast.confirmsetadmin")}}
                      </p>
                      <span  v-if="infor_admin.status_admin"  style="font-size: 18px;" class="font-weight-medium text-center" > 
                        {{ 
                          this.$t("toast.textsetadmin_3") + " " + infor_admin.name + " " + this.$t("toast.textsetadmin_2")
                          }}
                      </span>
                      <span  v-else  style="font-size: 18px;" class="font-weight-medium text-center" > 
                        {{ 
                          $t("toast.textsetadmin_1") + " " + infor_admin.name + " " + $t("toast.textsetadmin_2") 
                          }}
                      </span>
                    </div>
                </v-card-text>
                <v-card-actions class="d-flex flex-row align-center justify-center text-center pa-3 pb-4" >
                    <v-btn :color="color.theme" large   dark @click="fn_set_admin(infor_admin);">
                      {{ $t("admin.submit") }}
                    </v-btn>
                    <v-btn color="error" large @click="isConfirmAdmin = false">
                      {{ $t("default") === 'en' ? 'Cancel' : 'ยกเลิก' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
    <dialogconfirmcloseemployee
      :show="opendialogconfirmcloseemployee"
      @close="opendialogconfirmcloseemployee  = false "
      @close_and_reload="opendialogconfirmcloseemployee  = false , get_employee()"
      :data_employee="data_employee"
    ></dialogconfirmcloseemployee>
  </v-app>
</template>
<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import { mapState, mapGetters } from "vuex";
import "vue-full-screen-file-drop/dist/vue-full-screen-file-drop.css";
import onebox_admin_toolbar from "../components/layout/layout-admin-toolbar";
import gbfGenerate from "../globalFunctions/generateAuthorize";
const dialogconfirmcloseemployee = () => import("../components/optional/dialog-confirmcloseemployee.vue");


const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    onebox_admin_toolbar,
    dialogconfirmcloseemployee
  },
  data: function() {
    return {
      data_employee:{},
      opendialogconfirmcloseemployee: false,
      infor_admin: {
        name: "",
        status_admin: null,
        staff_id: ""
      },
      isConfirmAdmin: false,
      clicksearch: false,
      staff: [],
      all_data_employee: [],
      list_department:[],
      total_account: 0,
      loaddataprogresstable: false,
      search: [],
      detaildata: {},
      loaddataprogress: true,
      size: 20,
      offset: 0,
      page: 1,
      x: 0,
      y: 0,
      listsize: [10, 20, 50, 100],
      headerTH: [
        {
          text: "#",
          align: "center",
          value: "type",
          width: "7%",
          sortable: false,
        },
        {
          text: "admin.user_name",
          align: "",
          value: "first_name_th",
          width: "23%",
          sortable: false,
        },
        {
          text: "admin.department",
          align: "",
          value: "department_name",
          width: "20%",
          sortable: false,
        },
        {
          text: "admin.username",
          align: "",
          value: "username",
          width: "20%",
          sortable: false,
        },
        {
          text: "admin.business_email",
          align: "",
          value: "email",
          width: "23%",
          sortable: false,
        },
        {
          text: "admin.option",
          align: "center",
          value: "status",
          width: "7%",
          sortable: false,
        },
      ],
      headerEN: [
        {
          text: "#",
          align: "center",
          value: "type",
          width: "7%",
          sortable: false,
        },
        {
          text: "admin.user_name",
          align: "",
          value: "first_name_eng",
          width: "23%",
          sortable: false,
        },
        {
          text: "admin.department",
          align: "",
          value: "department_name",
          width: "20%",
          sortable: false,
        },
        {
          text: "admin.username",
          align: "",
          value: "username",
          width: "20%",
          sortable: false,
        },
        {
          text: "admin.business_email",
          align: "",
          value: "email",
          width: "23%",
          sortable: false,
        },
        {
          text: "admin.setting",
          align: "center",
          value: "status",
          width: "7%",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState(["username", "authorize", "account_active", "service", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
      "dataStorageUsage",
      "dataStorageMax",
    ]),
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    pageCount: {
      get() {
        let l = this.total_account;
        let s = this.size;
        return Math.ceil(l / s);
      },
      set(newName) {
        return newName;
      },
    },
    headerTable() {
      return "color:" + this.color.theme + ";" + "font-weight: 600; font-size:15px;";
    },
    headerPage() {
      // console.log(this.color.theme);

      return "color:" + this.color.theme + ";" + "font-size: 18px; font-weight: 600;";
    },
    colorVapp() {
      return "background:" + this.color.BG + ";";
    },
    colorSort() {
      return "color:" + this.color.alertText + ";";
    },
    colorProgress() {
      return "color:" + this.color.theme + ";";
    },
  },
  methods: {
    async get_employee() {
      this.loaddataprogress = true;
      this.all_data_employee = [];
      this.total_account = 0;
      console.log("get_employee");
      var payload = {
        business_id: this.dataAccountActive.business_info.business_id,
        account_id: this.dataAccountId,
        user_id: this.dataUsername,
        filter: ""
      };
      console.log("payload", payload);
      let auth = await gbfGenerate.generateToken();
      await this.axios
        .post(
          process.env.VUE_APP_SERVICE_AUTHORIZE_API +
            "/api/get_user_in_business_dedicated",
          payload,
          {
            headers: { Authorization: auth.code },
          }
        )
        .then((response) => {
          if (response.data.status === "OK") {
            console.log("ok", response);
            this.list_count_employee = response.data.data.length;
            for (let i = 0; i < response.data.data.length; i++) {
              let data_employee = {};
              data_employee["account_id"] = response.data.data[i]["account_id"];
              data_employee["account_title_eng"] =
                response.data.data[i]["account_title_eng"];
              data_employee["account_title_th"] =
                response.data.data[i]["account_title_th"];
              data_employee["business_id"] =
                response.data.data[i]["business_id"];
              //  data_employee["department"] = response.data.data[i]["department"].length > 0 ? response.data.data[i]["department"][0].department_name : 'ไม่มีแผนก';
              if (response.data.data[i]["department"].length > 0) {
                let count = 0;
                data_employee["department_id"] = [];
                data_employee["department_name"] = "";
                for (let item of response.data.data[i]["department"]) {
                  console.log("item", item);
                  data_employee["department_id"].push(item.department_id);
                  data_employee["department_name"] +=
                    count > 0
                      ? "," + " " + item.department_name
                      : item.department_name;
                  count++;
                }
              } else {
                data_employee["department_id"] = [];
                data_employee["department_name"] = this.$t(
                  "admin.no_department"
                );
              }
              data_employee["email"] = response.data.data[i]["email"];
              data_employee["first_name_eng"] =
                response.data.data[i]["first_name_eng"];
              data_employee["first_name_th"] =
                response.data.data[i]["first_name_th"];
              data_employee["last_name_eng"] =
                response.data.data[i]["last_name_eng"];
              data_employee["last_name_th"] =
                response.data.data[i]["last_name_th"];
              data_employee["mobile_no"] = response.data.data[i]["mobile_no"];
              data_employee["my_folder_id"] =
                response.data.data[i]["my_folder_id"];
              data_employee["permission_feature"] =
                response.data.data[i]["permission_feature"];
              data_employee["user_id"] = response.data.data[i]["user_id"];
              data_employee["username"] = response.data.data[i]["username"];
              
              this.all_data_employee.push(data_employee);
            }
            this.total_account = this.all_data_employee.length;
            console.log("this.all_data_employee",this.all_data_employee);
            
            for (let i = 0; i < response.data.department.length; i++) {
              let data_department = {};
              data_department["department_id"] =
                response.data.department[i]["id"];
              data_department["department_name"] =
                response.data.department[i]["department_name"];
              this.list_department.push(data_department);
            }
            console.log("this.list_department",this.list_department);
            this.loaddataprogress = false;
          } else {
            this.loaddataprogress = false;
            console.log("ok", response);
            Toast.fire({
              icon: "error",
              title: this.$t("ไม่สามารถดึงข้อมูลพนักงานได้"),
            });
          }
          this.loaddataemp = false
        })
        .catch((err) => {
          this.loaddataemp = false
          Toast.fire({
            icon: "error",
            title: this.$t("toast.cannotconnectonebox"),
          });
          this.loading = false;
        });
    },
    async search_employee(){
      this.loaddataprogress = true;
      this.all_data_employee = [];
      this.total_account = 0;
      console.log("get_employee");
      var payload = {
        business_id: this.dataAccountActive.business_info.business_id,
        account_id: this.dataAccountId,
        user_id: this.dataUsername,
        filter: this.search
      };
      console.log("payload", payload);
      let auth = await gbfGenerate.generateToken();
      await this.axios
        .post(
          process.env.VUE_APP_SERVICE_AUTHORIZE_API +
            "/api/get_user_in_business_dedicated",
          payload,
          {
            headers: { Authorization: auth.code },
          }
        )
        .then((response) => {
          if (response.data.status === "OK") {
            console.log("ok", response);
            this.list_count_employee = response.data.data.length;
            for (let i = 0; i < response.data.data.length; i++) {
              let data_employee = {};
              data_employee["account_id"] = response.data.data[i]["account_id"];
              data_employee["account_title_eng"] =
                response.data.data[i]["account_title_eng"];
              data_employee["account_title_th"] =
                response.data.data[i]["account_title_th"];
              data_employee["business_id"] =
                response.data.data[i]["business_id"];
              //  data_employee["department"] = response.data.data[i]["department"].length > 0 ? response.data.data[i]["department"][0].department_name : 'ไม่มีแผนก';
              if (response.data.data[i]["department"].length > 0) {
                let count = 0;
                data_employee["department_id"] = [];
                data_employee["department_name"] = "";
                for (let item of response.data.data[i]["department"]) {
                  console.log("item", item);
                  data_employee["department_id"].push(item.department_id);
                  data_employee["department_name"] +=
                    count > 0
                      ? "," + " " + item.department_name
                      : item.department_name;
                  count++;
                }
              } else {
                data_employee["department_id"] = [];
                data_employee["department_name"] = this.$t(
                  "admin.no_department"
                );
              }
              data_employee["email"] = response.data.data[i]["email"];
              data_employee["first_name_eng"] =
                response.data.data[i]["first_name_eng"];
              data_employee["first_name_th"] =
                response.data.data[i]["first_name_th"];
              data_employee["last_name_eng"] =
                response.data.data[i]["last_name_eng"];
              data_employee["last_name_th"] =
                response.data.data[i]["last_name_th"];
              data_employee["mobile_no"] = response.data.data[i]["mobile_no"];
              data_employee["my_folder_id"] =
                response.data.data[i]["my_folder_id"];
              data_employee["permission_feature"] =
                response.data.data[i]["permission_feature"];
              data_employee["user_id"] = response.data.data[i]["user_id"];
              data_employee["username"] = response.data.data[i]["username"];
              
              this.all_data_employee.push(data_employee);
            }
            this.total_account = this.all_data_employee.length;
            console.log("this.all_data_employee",this.all_data_employee);
            
            for (let i = 0; i < response.data.department.length; i++) {
              let data_department = {};
              data_department["department_id"] =
                response.data.department[i]["id"];
              data_department["department_name"] =
                response.data.department[i]["department_name"];
              this.list_department.push(data_department);
            }
            console.log("this.list_department",this.list_department);
            this.loaddataprogress = false;
            
          } else {
            this.loaddataprogress = false;
            console.log("ok", response);
            Toast.fire({
              icon: "error",
              title: this.$t("ไม่สามารถดึงข้อมูลพนักงานได้"),
            });
          }
        })
        .catch((err) => {
          this.loaddataprogress = false;
          Toast.fire({
            icon: "error",
            title: this.$t("toast.cannotconnectonebox"),
          });
          this.loading = false;
        });
    },
    opendialog_close_user(item){
      this.data_employee = item
      this.opendialogconfirmcloseemployee = true;
    },
    //เปลี่ยนหน้า
    clickpagination() {
      console.log(this.search, this.clicksearch);
      if (this.search !== null && this.search.length !== 0 && this.clicksearch === true) {
        this.fn_search_staff("c");
      } else {
        this.get_employee();
      }
    },
  },
  mounted() {
    this.get_employee();
    this.loaddataprogress = false;
  },
};
</script>
<style>
#thiscontainersetadmin {
  height: calc(101vh - 180px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -moz-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
}
</style>
